// built-from: /canonical-domain-scenarios v1 impl:canonical-domain-scenarios role:implementation
export const lumenGridEnergy = Object.freeze({
  id: 'lumen-grid-energy',
  name: 'LumenGrid Energy',
  initials: 'LG',
});

export const davidMorgan = Object.freeze({
  id: 'david-morgan',
  name: 'David Morgan',
  firstName: 'David',
  role: 'Modernisation consultant',
  email: 'david@dreamdev.com',
});

export const mayaByrne = Object.freeze({
  id: 'maya-byrne',
  name: 'Maya Byrne',
  role: 'Executive sponsor',
  email: 'maya@lumengrid.example',
});

export const kevinOSullivan = Object.freeze({
  id: 'kevin-osullivan',
  name: "Kevin O'Sullivan",
  role: 'Operations SME',
  email: 'kevin@lumengrid.example',
});

export const priyaNair = Object.freeze({
  id: 'priya-nair',
  name: 'Priya Nair',
  role: 'Technology lead',
  email: 'priya@lumengrid.example',
});

export const establishTrustedModernisationDirection = Object.freeze({
  id: 'establish-trusted-modernisation-direction',
  name: 'Establish a trusted modernisation direction',
  statement:
    'Establish an evidence-backed direction for replacing the platform incrementally and select a credible first fundable phase.',
});

export const accelerateProductChange = Object.freeze({
  id: 'accelerate-product-change',
  name: 'Accelerate product change',
  statement: 'Reduce the effort and risk involved in launching and changing products.',
});

export const alignBusinessAndTechnologyOwnership = Object.freeze({
  id: 'align-business-and-technology-ownership',
  name: 'Align business and technology ownership',
  statement: 'Align business responsibility, software boundaries and organisational ownership.',
});

export const selectCredibleFirstPhase = Object.freeze({
  id: 'select-credible-first-phase',
  name: 'Select a credible first phase',
  statement: 'Identify a fundable first intervention with understood value and risk.',
});

export const productChangeLeadTime = Object.freeze({
  id: 'product-change-lead-time',
  name: 'Product change lead time',
  baseline: 'Not yet established',
  target: 'Baseline and target to be agreed',
});

export const manualOperationalHandoffs = Object.freeze({
  id: 'manual-operational-handoffs',
  name: 'Manual operational handoffs',
  baseline: 'To be measured in priority value streams',
  target: 'Material reduction after the first intervention',
});

export const changeFailureRate = Object.freeze({
  id: 'change-failure-rate',
  name: 'Change failure rate',
  baseline: 'Evidence gathering in progress',
  target: 'Target to be calibrated from technical evidence',
});
